import * as types from './actionTypes';  
import statsOfferingOrdersApi from '../api/statsOfferingOrdersApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchStatsOfferingOrders(request) {

  return {
    type: types.DO_FETCH_STATS_OFFERING_ORDERS, 
    request
  };
}

export function doFetchStatsOfferingOrdersRes(data) {  
  return {
    type: types.DO_FETCH_STATS_OFFERING_ORDERS_RES, 
    data
  };
}

export function fetchStatsOfferingOrders(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      statsOfferingOrdersApi.doFetchStatsOfferingOrders(request).then(data => {
        dispatch(doFetchStatsOfferingOrdersRes(data));
        dispatch(doFetchStatsOfferingOrdersRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}